import { render, staticRenderFns } from "./orderVideoXcx.vue?vue&type=template&id=0b5f6ff4&scoped=true"
import script from "./orderVideoXcx.vue?vue&type=script&lang=js"
export * from "./orderVideoXcx.vue?vue&type=script&lang=js"
import style0 from "./orderVideoXcx.vue?vue&type=style&index=0&id=0b5f6ff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f6ff4",
  null
  
)

export default component.exports